export const SupportRequestIcon = () => (
	<svg
		fill="none"
		height="16"
		viewBox="0 0 16 16"
		width="16"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="support-request"
	>
		<path
			clipRule="evenodd"
			d="m1 3c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2zm2-.5c-.27614 0-.5.22386-.5.5v10c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-10c0-.27614-.2239-.5-.5-.5zm1 4.75h8v1.5h-8z"
			fill="#6a9a23"
			fillRule="evenodd"
		/>
	</svg>
);
